export const langList = [
  {
    label: "中文(普通话)",
    value: 0
  },
  {
    label: "中文(方言)",
    value: 8
  },
  {
    label: "中文(粤语)",
    value: 9
  },
  {
    label: "英语",
    value: 1
  },
  {
    label: "马来语",
    value: 2
  },
  {
    label: "日语",
    value: 3
  },
  {
    label: "越南语",
    value: 4
  },
  {
    label: "韩语",
    value: 5
  },
  {
    label: "法语",
    value: 6
  },
  {
    label: "印尼语",
    value: 7
  }
];
export function getMultiLang(lang: number) {
  // 0 中文 1 英语 2 马来语 3 日语 4 越南语 5 韩语 6 法语 7 印尼语 8 中文(方言) 9 中文(粤语)
  return langList[lang];
}
